import { useTranslation } from "react-i18next";
import { IconClose } from "@boligportal/bricks-icons";
import {
  Toaster as BricksToaster,
  Toast,
  toaster,
} from "@boligportal/bricks-ui";

export const toast = (message: string) =>
  toaster.create({ description: message });

export const Toaster = () => {
  const { t } = useTranslation(["global"]);

  return (
    // Portalled before any dialog, so without a z-index an open dialog covers its toasts.
    <BricksToaster
      aria-label={t("global:toast.region_label")}
      className="bottom-[calc(1rem+var(--app-update-offset,0px))] z-50"
    >
      {(item) => (
        <Toast.Root>
          <Toast.Description>{item.description}</Toast.Description>
          <Toast.CloseTrigger aria-label={t("global:toast.close")}>
            <IconClose />
          </Toast.CloseTrigger>
        </Toast.Root>
      )}
    </BricksToaster>
  );
};
